import * as Types from '@/__gen/types';

import { gql } from '@apollo/client';
import { MetricFormLinkEssentialsFragmentDoc } from '../../../../../../../../../../../fragments/__gen/index';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FormStatusMetricQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  teamId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  isSuiteAdminDashboard?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type FormStatusMetricQuery = { __typename: 'PharosQuery', formStatusMetric: { __typename: 'FormStatusMetricType', id: string, name: string, values: Array<{ __typename: 'PieChartSegmentType', name: string, color: string, formLinks: Array<{ __typename: 'MetricFormLink', formId: string, formTitle: string, recordId: string, recordName: string, fieldId: string | null, fieldTitle: string | null, organisationName: string, teamName: string }> }> } | null };


export const FormStatusMetricDocument = gql`
    query formStatusMetric($id: ID!, $teamId: ID, $isSuiteAdminDashboard: Boolean) {
  formStatusMetric(id: $id) {
    id
    name
    values(teamId: $teamId, isSuiteAdminDashboard: $isSuiteAdminDashboard) {
      name
      color
      formLinks {
        ...MetricFormLinkEssentials
      }
    }
  }
}
    ${MetricFormLinkEssentialsFragmentDoc}`;

/**
 * __useFormStatusMetricQuery__
 *
 * To run a query within a React component, call `useFormStatusMetricQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormStatusMetricQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormStatusMetricQuery({
 *   variables: {
 *      id: // value for 'id'
 *      teamId: // value for 'teamId'
 *      isSuiteAdminDashboard: // value for 'isSuiteAdminDashboard'
 *   },
 * });
 */
export function useFormStatusMetricQuery(baseOptions: Apollo.QueryHookOptions<FormStatusMetricQuery, FormStatusMetricQueryVariables> & ({ variables: FormStatusMetricQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormStatusMetricQuery, FormStatusMetricQueryVariables>(FormStatusMetricDocument, options);
      }
export function useFormStatusMetricLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormStatusMetricQuery, FormStatusMetricQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormStatusMetricQuery, FormStatusMetricQueryVariables>(FormStatusMetricDocument, options);
        }
export function useFormStatusMetricSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FormStatusMetricQuery, FormStatusMetricQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FormStatusMetricQuery, FormStatusMetricQueryVariables>(FormStatusMetricDocument, options);
        }
export type FormStatusMetricQueryHookResult = ReturnType<typeof useFormStatusMetricQuery>;
export type FormStatusMetricLazyQueryHookResult = ReturnType<typeof useFormStatusMetricLazyQuery>;
export type FormStatusMetricSuspenseQueryHookResult = ReturnType<typeof useFormStatusMetricSuspenseQuery>;
export type FormStatusMetricQueryResult = Apollo.QueryResult<FormStatusMetricQuery, FormStatusMetricQueryVariables>;